import { API_URL } from "../constants";

export const GET_ALL_CREDITS = `${API_URL}credit/public/`
export const GET_CREDIT = (id: any) =>`${API_URL}credit/public/${id}`
export const GET_RANK_CREDITS = `${API_URL}credit/public/rank/`
export const GET_CREDIT_RESULTS = (idCredit: any, idPlazo: any, amount: any) => `${API_URL}credit/public/calculatorSimple/${idCredit}/${idPlazo}/${amount}`
export const GET_CREDIT_RESULTS_MODAL = (idCredit: any, idPlazo: any, amount: any) => `${API_URL}credit/public/calculator/${idCredit}/${idPlazo}/${amount}`

export const POST_LEAD = `${API_URL}lead/public/LeadAvantthya/`;